var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorkplaceConflict(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.998047 15.312H9.32452",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.93435 8.6884C7.93435 8.18693 7.52691 7.76904 7.01499 7.76904H5.41656C4.89419 7.76904 4.39273 7.97799 4.02707 8.34364L3.05548 9.31524C2.68982 9.68089 2.48088 10.1928 2.48088 10.7047H1.00781",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.43262 12.7213C4.49824 12.7213 5.37581 11.8542 5.37581 10.7781V9.52441H6.61903V9.7647C6.61903 10.0572 6.75485 10.3184 6.96379 10.496",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2748 9.51381C10.2748 9.97349 9.9091 10.3391 9.44942 10.3391H7.93457V8.68848H9.44942C9.9091 8.68848 10.2748 9.05413 10.2748 9.51381Z",
    stroke: "black",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9538 11.1749C10.9538 11.6346 10.5881 12.0003 10.1284 12.0003H7.4435C6.98382 12.0003 6.61816 11.6346 6.61816 11.1749C6.61816 10.9033 6.75398 10.6526 6.96292 10.5063C7.11963 10.6421 7.32858 10.7257 7.55842 10.7257C7.76736 10.7257 7.93452 10.5586 7.93452 10.3496H10.1284C10.5881 10.3496 10.9538 10.7153 10.9538 11.1749Z",
    stroke: "black",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1284 12H7.4435C6.98768 12 6.61816 12.3695 6.61816 12.8253C6.61816 13.2812 6.98768 13.6507 7.4435 13.6507H10.1284C10.5843 13.6507 10.9538 13.2812 10.9538 12.8253C10.9538 12.3695 10.5843 12 10.1284 12Z",
    stroke: "black",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.44937 13.6509H7.4435C6.98768 13.6509 6.61816 14.0204 6.61816 14.4762C6.61816 14.932 6.98768 15.3015 7.4435 15.3015H9.44937C9.90519 15.3015 10.2747 14.932 10.2747 14.4762C10.2747 14.0204 9.90519 13.6509 9.44937 13.6509Z",
    stroke: "black",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6738 15.312H23.0003",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0017 10.715H21.5287C21.5287 10.1926 21.3197 9.69115 20.9541 9.32549L19.9825 8.3539C19.6168 7.98824 19.1049 7.7793 18.593 7.7793H16.9946C16.4931 7.7793 16.0752 8.18674 16.0752 8.69866",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0459 10.5058C17.2548 10.3282 17.3907 10.067 17.3907 9.77447V9.53418H18.6339V10.7879C18.6339 11.8535 19.501 12.731 20.5771 12.731",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7246 9.51332C13.7246 9.973 14.0903 10.3387 14.5499 10.3387H16.0648V8.68799H14.5499C14.0903 8.68799 13.7246 9.05364 13.7246 9.51332Z",
    stroke: "black",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0449 11.1745C13.0449 11.6341 13.4106 11.9998 13.8703 11.9998H16.5552C17.0149 11.9998 17.3805 11.6341 17.3805 11.1745C17.3805 10.9028 17.2447 10.6521 17.0358 10.5058C16.8791 10.6416 16.6701 10.7252 16.4403 10.7252C16.2313 10.7252 16.0642 10.5581 16.0642 10.3491H13.8703C13.4106 10.3491 13.0449 10.7148 13.0449 11.1745Z",
    stroke: "black",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8803 13.6504H16.5653C17.0211 13.6504 17.3906 13.2809 17.3906 12.8251C17.3906 12.3692 17.0211 11.9997 16.5653 11.9997H13.8803C13.4245 11.9997 13.055 12.3692 13.055 12.8251C13.055 13.2809 13.4245 13.6504 13.8803 13.6504Z",
    stroke: "black",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5594 15.312H16.5653C17.0211 15.312 17.3906 14.9425 17.3906 14.4867C17.3906 14.0309 17.0211 13.6613 16.5653 13.6613H14.5594C14.1036 13.6613 13.7341 14.0309 13.7341 14.4867C13.7341 14.9425 14.1036 15.312 14.5594 15.312Z",
    stroke: "black",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M12.001 4.88536V3.34961",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M8.91855 6.16005L7.83203 5.08398",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M15.083 6.16005L16.1695 5.08398",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M12.001 19.1143V20.65",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M8.91855 17.8398L7.83203 18.9159",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M15.083 17.8398L16.1695 18.9159",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkplaceConflict);
export default __webpack_public_path__ + "static/media/Workplace Conflict.70e9e37aa0817246db6d1c15f26935b1.svg";
export { ForwardRef as ReactComponent };